// extracted by mini-css-extract-plugin
export default {"confirmationContainer":"MnhroaD0ea8HfFQgoNOw","confirmationCard":"fOtoOkHXWS6hn1kPx66O","message":"d1Z_QOBj17y0lEyQjzzk","subMessage":"QjyNGc7ZNaOPLHHJ6Gcl"};